import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   fleetReportApiCall,
   fleetMaintainanceReportApiCall,
   customerMasterReportApiCall,
   vendorMasterReportApiCall,
   driverMasterReportApiCall,
   helperMasterReportApiCall,
   contractorMasterReportApiCall,
   laneMasterReportApiCall,
   tripMasterReportApiCall,
} from "../../Api/api";

// initial state
const initialState = {
   fleetReport: null,
   fleetMaintainanceReport: null,
   customerMasterReport: null,
   vendorMasterReport: null,
   driverMasterReport: null,
   helperMasterReport: null,

   isLoading: false,
   isError: false,
   isSuccess: false,
};

// add fleet
export const fleetReportAsync = createAsyncThunk(
   "report/fleet-report",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await fleetReportApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done(response.data?.res);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Fleet Maintainance Report Async
export const fleetMaintainanceReportAsync = createAsyncThunk(
   "report/fleet-maintainance-report",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await fleetMaintainanceReportApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done(response.data?.res);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Customer Master Report Async
export const customerMasterReportAsync = createAsyncThunk(
   "report/customer-master-report",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await customerMasterReportApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done(response.data?.res);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Vendor Master Report Async
export const vendorMasterReportAsync = createAsyncThunk(
   "report/vendor-master-report",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await vendorMasterReportApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done(response.data?.res);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Driver Master Report Async
export const driverMasterReportAsync = createAsyncThunk(
   "report/driver-master-report",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await driverMasterReportApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done(response.data?.res);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Helper Master Report Async
export const helperMasterReportAsync = createAsyncThunk(
   "report/helper-master-report",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await helperMasterReportApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done(response.data?.res);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Contractor Master Report Async
export const contractorMasterReportAsync = createAsyncThunk(
   "report/contractor-master-report",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await contractorMasterReportApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done(response.data?.res);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Lane Master Report Async
export const laneMasterReportAsync = createAsyncThunk(
   "report/lane-master-report",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await laneMasterReportApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done(response.data?.res);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Trip Master Report Async
export const tripMasterReportAsync = createAsyncThunk(
   "report/trip-master-report",
   async ({ data, err, done, params = {} }, thunkAPI) => {
      try {
         const response = await tripMasterReportApiCall(data, params);

         if (response.data?.statusCode === 200) {
            done && done(response.data?.res);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// reports
const reportSlice = createSlice({
   name: "reports",

   initialState: initialState,

   reducers: {
      clearDriverMasterState: (state, action) => {
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },

   extraReducers: (builder) => {
      //
      builder.addCase(fleetReportAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fleetReportAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.fleetReport = action.payload;
      });
      builder.addCase(fleetReportAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = true;
      });

      // Fleet Maintenance Report
      builder.addCase(fleetMaintainanceReportAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fleetMaintainanceReportAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.fleetMaintainanceReport = action.payload;
      });
      builder.addCase(fleetMaintainanceReportAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = true;
      });

      // Customer Master Report
      builder.addCase(customerMasterReportAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(customerMasterReportAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.customerMasterReport = action.payload;
      });
      builder.addCase(customerMasterReportAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = true;
      });

      // Vendor Master Report
      builder.addCase(vendorMasterReportAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(vendorMasterReportAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.vendorMasterReport = action.payload;
      });
      builder.addCase(vendorMasterReportAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = true;
      });

      // Driver Master Report
      builder.addCase(driverMasterReportAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(driverMasterReportAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.driverMasterReport = action.payload;
      });
      builder.addCase(driverMasterReportAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = true;
      });

      // Helper Master Report
      builder.addCase(helperMasterReportAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(helperMasterReportAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.helperMasterReport = action.payload;
      });
      builder.addCase(helperMasterReportAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = true;
      });

      // Contractor Master Report
      builder.addCase(contractorMasterReportAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(contractorMasterReportAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.contractorMasterReport = action.payload;
      });
      builder.addCase(contractorMasterReportAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = true;
      });

      // Lane Master Report
      builder.addCase(laneMasterReportAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(laneMasterReportAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.laneMasterReport = action.payload;
      });
      builder.addCase(laneMasterReportAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = true;
      });

      // Trip Master Report
      builder.addCase(tripMasterReportAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(tripMasterReportAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.tripMasterReport = action.payload;
      });
      builder.addCase(tripMasterReportAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = true;
      });
   },
});

const reportReducer = reportSlice.reducer;
export default reportReducer;
